// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"269ef7d7","468":"f502ae1c","616":"73db1600","673":"ad1d04c4","772":"a6bf1240","903":"be85621d"}[chunkId] + ".chunk.js";
};